import { CheckoutState } from '../reducers';

export const getErrorMessageState = (state: CheckoutState) => state.errorMessage;
